import {useEffect, useState} from 'react';
import server from "../server";

export interface AuditInfo {
    createdOn: string;
    createdBy: string;
}

export type LeaveTypeEnum = string;

export interface LeaveType {
    id: string;
    type: LeaveTypeEnum;
    paidType: string;
    description: string;
    markDefault: boolean;
    auditInfo: AuditInfo;
    active: boolean;
}

export const useLeaveTypes = () => {
    const [leaveTypes, setLeaveTypes] = useState<LeaveType[]>([]);
    const [loading, setLoading] = useState(true);

    const fetchLeaveTypes = async () => {
        try {
            const response = await server.settings.leaveType.list();
            const activeTypes = response.filter((type: any) => type.active);
            setLeaveTypes(activeTypes);
        } catch (error) {
            console.error("Failed to fetch leave types:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchLeaveTypes();
    }, []);

    return {leaveTypes, loading};
};
